import { queryOptions } from "@tanstack/react-query";

import { useApi } from "@/api/hooks/useApi";
import { commonAPIDataSelector } from "@/helpers/Network/selectors";
import { useProjectId } from "@/hooks/Network/useProjectId";
import { QUERY_KEYS } from "@/query-keys";

export const usePollQueries = () => {
  const projectId = useProjectId();
  const api = useApi();

  return {
    details: (pollId: string) =>
      queryOptions({
        queryKey: QUERY_KEYS.POLL_DETAILS(projectId, pollId),
        queryFn: () => api.getPollsDetailsV1(pollId),
        select: commonAPIDataSelector,
        staleTime: Infinity,
      }),
    answers: (pollId: string) =>
      queryOptions({
        queryKey: QUERY_KEYS.POLL_ANSWERS(projectId, pollId),
        queryFn: () => api.getPollsAnswersV1(pollId),
        select: commonAPIDataSelector,
      }),
    reach: (pollId: string) =>
      queryOptions({
        queryKey: QUERY_KEYS.POLL_REACH(projectId, pollId),
        queryFn: () => api.getPollsReachV1(pollId),
        select: commonAPIDataSelector,
      }),
    translation: ({ pollId, languageId }: { pollId: string; languageId: string }) =>
      queryOptions({
        queryKey: QUERY_KEYS.POLL_TRANSLATION(projectId, pollId, languageId),
        queryFn: () => api.getPollsTranslationsDetailsV2(pollId, languageId),
        select: commonAPIDataSelector,
        retry: false,
      }),
  };
};
